export const getErrorMessage = (error: unknown, fallback = "") => {
	if (error instanceof Error) return error.message;
	if (typeof error === "string") return error;
	if (error && typeof error === "object" && "message" in error) {
		return String(error.message ?? fallback);
	}
	return fallback;
};
